/* 🤖 this file was generated by svg-to-ts*/
export const icoDeleteKey: {
  name: 'delete-key';
  data: string;
} = {
  name: 'delete-key',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.122 5H8.79a1 1 0 00-.698.284l-5.533 5.397a1.842 1.842 0 00-.007 2.637l5.474 5.394a1 1 0 00.702.288h11.394A1.868 1.868 0 0022 17.143V6.857A1.868 1.868 0 0020.122 5zM20 7v10H9.138l-5.071-4.997L9.196 7H20zm-3 1a.97.97 0 00-.629.224l-.081.076L14 10.59l-2.29-2.3a1.003 1.003 0 00-1.504 1.324l.084.096 2.3 2.29-2.3 2.29A1.003 1.003 0 0011 16a.97.97 0 00.629-.224l.081-.076L14 13.41l2.29 2.3a1.003 1.003 0 001.504-1.324l-.084-.096-2.3-2.29 2.3-2.29A1.003 1.003 0 0017 8z" fill="#909090"/></svg>`
};
